// 基礎套件引入
import Vue from 'vue'
import App from './App'

// Element UI 相關配置
import Element from 'element-ui'
// 移除預設 CSS 導入，使用自定義主題（在 element-variables.scss 中定義）
// import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-TW'
import defaultSettings from '@/settings'

// 樣式引入
import 'normalize.css/normalize.css'
import '@/styles/index.scss' // element-variables.scss 已在 index.scss 中導入

// 路由和狀態管理
import router from './router'
import store from './store'

// 全局功能引入
import './icons'
import './permission'
import * as filters from './filters'
import * as utils from './utils'

// 自定義指令
import waves from '@/directive/waves'
import permission from '@/directive/permission'

// 第三方套件
import axios from 'axios'
import VueCryptojs from 'vue-cryptojs'

// Element UI 初始化配置
Vue.use(Element, {
  size: defaultSettings.themeSize,
  locale
})

// 註冊全局指令
Vue.use(waves)
Vue.use(permission)
Vue.use(VueCryptojs)

// 註冊全局工具方法
Object.keys(utils).forEach((key) => {
  Vue.prototype[key] = utils[key]
})

// 註冊全局過濾器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

// Vue 全局配置
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.eventbus = new Vue()

// 創建 Vue 根實例
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App)
})
